/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface FieldValidation { 
    validationType: FieldValidation.ValidationTypeEnum;
    validationValue: string;
    fieldId: string;
}
export namespace FieldValidation {
    export type ValidationTypeEnum = 'REGEX' | 'MIN_LENGTH' | 'MAX_LENGTH';
    export const ValidationTypeEnum = {
        Regex: 'REGEX' as ValidationTypeEnum,
        MinLength: 'MIN_LENGTH' as ValidationTypeEnum,
        MaxLength: 'MAX_LENGTH' as ValidationTypeEnum
    };
}


